'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isArrayOfStrings;

var _isString = require('./isString');

var _isString2 = _interopRequireDefault(_isString);

var _isArray = require('./isArray');

var _isArray2 = _interopRequireDefault(_isArray);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Check if an array consists of strings
 *
 * @param {Array} arrayToCheck The array to be checked for string values
 * @returns {boolean} True when the array contains just string otherwise false
 *
 * @example
 * isArrayOfStrings(['Mark', 'John']) // Returns: true
 * isArrayOfStrings([{name: 'Mark'}, {name: 'John'}]) // Returns: false
 */
function isArrayOfStrings(arrayToCheck) {
  return (0, _isArray2.default)(arrayToCheck) && arrayToCheck.reduce(function (currentStatus, value) {
    return currentStatus && (0, _isString2.default)(value);
  }, true);
}
//# sourceMappingURL=isArrayOfStrings.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-utilizr/lib/isArrayOfStrings.js
 ** module id = 316
 ** module chunks = 0
 **/